<template>
  <div class="account-page">
    <Button type="primary" icon="plus-round" v-if="permissions === true" @click="edit(0)">{{$t("system.Account.New_account")}}</Button>
    <Button type="primary" icon="plus-round" v-if="permissions !== true" @click="edit(0)" disabled>{{$t("system.Account.New_account")}}</Button>
    <!-- <el-table class="account-table" highlight-row stripe border :data="datas" :default-sort = "{prop: 'username', order: 'ascending'}" :row-class-name="tableRowClassName"> -->
    <el-table class="account-table" highlight-row stripe border :data="datas" :default-sort = "{prop: 'username', order: 'ascending'}">
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" inline class="demo-table-expand">
            <el-form-item :label="$t('system.Account.telephone')">
              <span>{{ props.row.phone }}</span>
            </el-form-item>
            <el-form-item :label="$t('system.Account.email')">
              <span>{{ props.row.eMail }}</span>
            </el-form-item>
            <el-form-item :label="$t('system.Account.qq')">
              <span>{{ props.row.qq }}</span>
            </el-form-item>
            <el-form-item :label="$t('system.Account.wechat')">
              <span>{{ props.row.wechat }}</span>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column type="index" :label="$t('system.Account.index')" width="65px"></el-table-column>
      <el-table-column prop="username" :label="$t('system.Account.User_name')" sortable></el-table-column>
      <el-table-column prop="name" :label="$t('system.Account.Name')" sortable></el-table-column>
      <el-table-column prop="workNo" :label="$t('system.Account.Worker_number')" sortable></el-table-column>
      <!-- <el-table-column prop="DepartmentName" :label="$t('system.Account.Department')"></el-table-column> -->
      <el-table-column prop="RoleName" :label="$t('system.Account.Role')"></el-table-column>
      <el-table-column :label="$t('system.Account.operating')" width="220px">
        <template slot-scope="scope" >
          <el-button v-if="permissions === true" @click.native="edit(scope.row.id)" type="primary" size="small">{{$t('system.Account.edit')}}</el-button>
          <el-button v-if="permissions === true" @click.native="reset(scope.row.id)" type="primary" size="small">{{$t('system.Account.reseat')}}</el-button>
          <el-button v-if="permissions === true" @click.native="remove(scope.row.id, scope.$index)" type="danger" size="small">{{$t('system.Account.delete')}}</el-button>
          <el-button v-if="permissions !== true" type="primary" size="small" disabled>{{$t('system.Account.edit')}}</el-button>
          <el-button v-if="permissions !== true" size="small" disabled>{{$t('system.Account.reseat')}}</el-button>
          <el-button v-if="permissions !== true" type="danger" size="small" disabled>{{$t('system.Account.delete')}}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- <Table class="account-table" highlight-row stripe border :columns="columns" :data="datas"></Table> -->
  </div>
</template>
<script>
import { Api } from '@/api'
import ExtraRow from './ExtraRow.vue'
export default {
  name: 'Account',
  components: { ExtraRow },
  data () {
    return {
      // columns: [
      //   {
      //     type: 'expand',
      //     width: 50,
      //     render: (h, params) => {
      //       return h(ExtraRow, {
      //         props: {
      //           row: params.row
      //         }
      //       })
      //     }
      //   },
      //   { type: 'index', title: '序号' },
      //   { title: this.$t('system.Account.User_name'), key: 'username' },
      //   { title: this.$t('system.Account.Name'), key: 'name' },
      //   { title: this.$t('system.Account.Worker_number'), key: 'workNo' },
      //   {
      //     title: this.$t('system.Account.Department'),
      //     key: 'department',
      //     render: (h, params) => {
      //       let department = ''
      //       for (let d of this.departments) {
      //         if (d.id === params.row.department) {
      //           department = d.name
      //         }
      //       }
      //       return h('span', department)
      //     }
      //   },
      //   {
      //     title: this.$t('system.Account.Role'),
      //     key: 'role',
      //     render: (h, params) => {
      //       let role = ''
      //       for (let r of this.roles) {
      //         if (r.id === params.row.role) {
      //           role = r.name
      //           // console.log('hh')
      //         }
      //       }
      //       return h('span', role)
      //     }
      //   },
      //   {
      //     title: this.$t('system.Account.operating'),
      //     key: 'action',
      //     render: (h, params) => {
      //       if (this.permissions === true) {
      //         return h('div', [
      //           h('Button', {
      //             props: {
      //               type: 'primary',
      //               size: 'small'
      //             },
      //             style: {
      //               marginRight: '5px'
      //             },
      //             on: {
      //               click: () => {
      //                 this.edit(params.index)
      //               }
      //             }
      //           }, this.$t('system.Account.edit')),
      //           h('Button', {
      //             props: {
      //               type: 'primary',
      //               size: 'small'
      //             },
      //             style: {
      //               marginRight: '5px'
      //             },
      //             on: {
      //               click: () => {
      //                 this.reset(params.index)
      //               }
      //             }
      //           }, this.$t('system.Account.reseat')),
      //           h('Button', {
      //             props: {
      //               type: 'error',
      //               size: 'small'
      //             },
      //             on: {
      //               click: () => {
      //                 if (confirm(this.$t('system.Account.delete_message'))) {
      //                   this.remove(params.index)
      //                 }
      //               }
      //             }
      //           }, this.$t('system.Account.delete'))
      //         ])
      //       // } else if (this.permissions === true) {
      //       //   return h('div', [
      //       //     h('Button', {
      //       //       props: {
      //       //         type: 'primary',
      //       //         size: 'small'
      //       //       },
      //       //       style: {
      //       //         marginRight: '5px'
      //       //       },
      //       //       on: {
      //       //         click: () => {
      //       //           this.edit(params.index)
      //       //         }
      //       //       }
      //       //     }, this.$t('system.Account.edit')),
      //       //     h('Button', {
      //       //       props: {
      //       //         type: 'primary',
      //       //         size: 'small'
      //       //       },
      //       //       style: {
      //       //         marginRight: '5px'
      //       //       },
      //       //       on: {
      //       //         click: () => {
      //       //           this.reset(params.index)
      //       //         }
      //       //       }
      //       //     }, this.$t('system.Account.reseat'))
      //       //   ])
      //       } else {
      //         return h('div', [
      //           h('Button', {
      //             props: {
      //               type: 'primary',
      //               size: 'small',
      //               disabled: true
      //             },
      //             style: {
      //               marginRight: '5px'
      //             }
      //           }, this.$t('system.Account.edit')),
      //           h('Button', {
      //             props: {
      //               type: 'primary',
      //               size: 'small',
      //               disabled: true
      //             },
      //             style: {
      //               marginRight: '5px'
      //             }
      //           }, this.$t('system.Account.reseat'))
      //         ])
      //       }
      //     }
      //   }
      // ],
      datas: [],
      roles: [],
      departments: [],
      permissions: false
    }
  },
  methods: {
    edit (id) {
      // id === -1 ? 0 : id
      this.$router.push({ name: 'AccountEdit', params: { id } })
    },
    remove (id, index) {
      // console.log(index, id)
      if (confirm(this.$t('system.Account.delete_message'))) {
        this.$api.account.delete(id).then(() => {
          this.datas.splice(index, 1)
        })
      }
    },
    reset (id) {
      // console.log(index)
      this.$api.account.reset(id).then(() => {
      })
    }
    // tableRowClassName (row, index) {
    //   // 把每一行的索引放进row
    //   row.index = index
    // }
  },
  mounted () {
    // Api.department.list().then(res => {
    //   this.departments = res.departments
    //   for (let i = 0; i < this.datas.length; i++) {
    //     for (let j = 0; j < this.departments.length; j++) {
    //       if (this.departments[j].id === this.datas[i].department) {
    //         this.datas[i].DepartmentName = this.departments[j].name
    //       }
    //     }
    //   }
    // })
    // Api.role.list().then(res => {
    //   this.roles = res.roles
    //   for (let i = 0; i < this.datas.length; i++) {
    //     for (let j = 0; j < this.roles.length; j++) {
    //       if (this.roles[j].id === this.datas[i].role) {
    //         this.datas[i].RoleName = this.roles[j].name
    //       }
    //     }
    //   }
    // })
    Api.user.fetchUserInfo().then(res => {
      for (let i = 0; i < res.user.permissions.length; i++) {
        if (res.user.permissions[i].action === 'system' && res.user.permissions[i].value === 3) {
          this.permissions = true
        }
      }
    })
  },
  beforeRouteEnter (to, from, next) {
    Api.account.list().then(res => {
      next(vm => {
        vm.datas = res.accounts
        let d = []
        for (let i = 0; i < vm.datas.length; i++) {
          if (vm.datas[i].username !== 'admin') {
            d.push(vm.datas[i])
          }
        }
        vm.datas = d
      })
    })
  }
}
</script>
<style>
.account-page {
  padding: 10px;
}
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
.account-table {
  margin-top: 20px;
}
</style>





// WEBPACK FOOTER //
// Account.vue?9e9b102c